import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=60fe715c&scoped=true"
import script from "./Teams.vue?vue&type=script&lang=js"
export * from "./Teams.vue?vue&type=script&lang=js"
import style0 from "./Teams.vue?vue&type=style&index=0&id=60fe715c&prod&lang=scss&scoped=true"
import style1 from "./Teams.vue?vue&type=style&index=1&id=60fe715c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe715c",
  null
  
)

export default component.exports